<template>
  <aside class="flex flex-col w-64 border-r border-border bg-sidebar text-sidebar-foreground">
    <div class="flex items-center gap-3 p-4 border-b border-sidebar-border">
      <div class="flex items-center justify-center w-8 h-8 rounded-lg bg-sidebar-primary text-sidebar-primary-foreground font-bold text-sm">
        BM
      </div>
      <span class="font-semibold text-lg">Beit Midrash</span>
    </div>

    <nav class="flex flex-col flex-1 gap-1 p-3">
      <span class="text-xs font-medium text-muted-foreground px-3 py-2">Main</span>
      <router-link
        v-for="item in mainNav"
        :key="item.to"
        :to="item.to"
        class="flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
        active-class="bg-sidebar-accent text-sidebar-accent-foreground font-medium"
      >
        {{ item.label }}
      </router-link>

      <template v-if="authStore.isAdmin">
        <Separator class="my-2" />
        <span class="text-xs font-medium text-muted-foreground px-3 py-2">Admin</span>
        <router-link
          v-for="item in adminNav"
          :key="item.to"
          :to="item.to"
          class="flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
          active-class="bg-sidebar-accent text-sidebar-accent-foreground font-medium"
        >
          {{ item.label }}
        </router-link>
      </template>
    </nav>

    <div class="flex items-center gap-3 p-4 border-t border-sidebar-border">
      <Avatar class="h-8 w-8">
        <AvatarImage v-if="authStore.currentUser?.photoThumbnailUrl" :src="authStore.currentUser.photoThumbnailUrl" />
        <AvatarFallback>{{ initials }}</AvatarFallback>
      </Avatar>
      <div class="flex flex-col flex-1 min-w-0">
        <span class="text-sm font-medium truncate">
          {{ authStore.currentUser?.firstName }} {{ authStore.currentUser?.lastName }}
        </span>
        <span class="text-xs text-muted-foreground truncate">
          {{ authStore.currentUser?.role }}
        </span>
      </div>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/authStore'
import { Separator } from '@/components/ui/separator'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

const authStore = useAuthStore()

const initials = computed(() => {
  const user = authStore.currentUser
  if (!user) return '?'
  return (user.firstName?.[0] ?? '') + (user.lastName?.[0] ?? '')
})

const mainNav = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/sessions', label: 'Sessions' },
  { to: '/my-debates', label: 'My Debates' },
  { to: '/profile', label: 'Profile' },
]

const adminNav = [
  { to: '/admin', label: 'Admin Dashboard' },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/topics', label: 'Topics' },
  { to: '/admin/sessions', label: 'Sessions' },
  { to: '/admin/pairing-history', label: 'Pairing History' },
]
</script>
